import loadable from '@loadable/component';
import { LOADABLE_NO_SSR } from 'shared/utils/loadable';

export const NewbuildingBrokerCallbackWidgetAdapterLoadable = loadable(
  () =>
    import('./NewbuildingBrokerCallbackWidgetAdapter').catch(
      /* istanbul ignore next */ () => ({ NewbuildingBrokerCallbackWidgetAdapter: () => null }),
    ),
  {
    resolveComponent: ({ NewbuildingBrokerCallbackWidgetAdapter }) => NewbuildingBrokerCallbackWidgetAdapter,
    ...LOADABLE_NO_SSR,
  },
);
